module.exports = __webpack_public_path__ + "img/AppStore.9768b4de.svg";